// extracted by mini-css-extract-plugin
module.exports = {"document":"_3TT18A9u2AfTfrs0nNML","requires-acceptance-checkbox":"_3upDh7-SPT04nYUp7gyv"};